document.addEventListener('DOMContentLoaded', function() {
  const STORAGE_KEY = 'new_notifications';
  const hasNewNotifications = localStorage.getItem(STORAGE_KEY);

  // Select all notification trigger buttons on the page
  const notificationTriggers = document.querySelectorAll('.site-nav__notifications');

  // If there are no notification triggers, do nothing
  if (notificationTriggers.length === 0) {
    return;
  }

  // --- 1. GLOBAL STATE MANAGEMENT ---

  // This function updates the visibility of all notification bubbles
  const updateAllBubbles = (visible) => {
    const allBubbles = document.querySelectorAll('.notifications__bubble');
    allBubbles.forEach(bubble => {
      if (visible) {
        bubble.classList.add('notifications__bubble--visible');
      } else {
        bubble.classList.remove('notifications__bubble--visible');
      }
    });
  };

  // This function marks notifications as read and updates the global state
  const markAsChecked = () => {
    localStorage.setItem(STORAGE_KEY, 'false');
    updateAllBubbles(false);
  };

  // --- 2. INITIALIZATION ---

  // Check if this is the first time the user is seeing the notifications
  const firstNotification = document.querySelector('.notification-list > *');
  if (hasNewNotifications === null && firstNotification) {
    localStorage.setItem(STORAGE_KEY, 'true');
  }

  // Set the initial visibility of the bubbles based on storage
  if (localStorage.getItem(STORAGE_KEY) === 'true') {
    updateAllBubbles(true);
  }

  // --- 3. BIND EVENTS TO EACH NOTIFICATION COMPONENT ---

  notificationTriggers.forEach(triggerBtn => {
    const parent = triggerBtn.parentElement;
    if (!parent) return;

    const dropdown = parent.querySelector('.notification-dropdown');
    const closeBtn = parent.querySelector('.close-notifications');

    if (!dropdown) return;

    const openDropdown = () => {
      dropdown.classList.add('is-active');
      dropdown.setAttribute('aria-hidden', 'false');
      markAsChecked(); // Mark as read when any dropdown is opened
    };

    const closeDropdown = () => {
      dropdown.classList.remove('is-active');
      dropdown.setAttribute('aria-hidden', 'true');
    };

    const toggleDropdown = () => {
      dropdown.classList.contains('is-active') ? closeDropdown() : openDropdown();
    };

    // --- 4. EVENT LISTENERS ---

    // Open/Close Dropdown
    triggerBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      toggleDropdown();
    });

    // Close Button (inside dropdown)
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        closeDropdown();
      });
    }
  });

  // Global listener to close any active dropdown when clicking outside
  document.addEventListener('click', function(event) {
    const activeDropdown = document.querySelector('.notification-dropdown.is-active');
    if (activeDropdown) {
      const trigger = document.querySelector(`[aria-controls="${activeDropdown.id}"]`);
      const isClickInside = activeDropdown.contains(event.target) || (trigger && trigger.contains(event.target));
      if (!isClickInside) {
        activeDropdown.classList.remove('is-active');
        activeDropdown.setAttribute('aria-hidden', 'true');
      }
    }
  });

  // --- FOR TESTING ONLY: RESET BUTTON ---
  window.resetNotifications = function() {
    localStorage.removeItem(STORAGE_KEY);
    alert('Notifications reset! Refresh the page to see the red bubble.');
    location.reload();
  };
});